module.exports = __webpack_public_path__ + "media/src/application/media/icon-logo-1b4914da5f71a35639c1f117bff6fe74.png";